import Base from './Base';

export type ApiLocationsResponse = ApiListResponse<Location>;
export type ApiLocationTypesResponse = ApiListResponse<LocationType>;
export type ApiRegionsResponse = ApiListResponse<Region>;

class Locations extends Base {
    get(query = null, page = null, count = null, opts = null) {
        return this.getJSON<ApiLocationsResponse>(
            '/locations',
            {
                ...(page !== null ? { page } : null),
                ...(count !== null ? { count } : null),
                ...query,
            },
            opts,
        );
    }

    findBySlug(slug, opts = null): Promise<Location | null> {
        return this.getJSON<Location>(
            '/locations',
            {
                uri: slug,
            },
            opts,
        ).catch((e) => {
            if (e.status === 404) {
                return null;
            }
            throw e;
        });
    }

    locationTypes(query = null, page = null, count = null, opts = null) {
        return this.getJSON<ApiLocationTypesResponse>(
            '/location-types',
            {
                ...(page !== null ? { page } : null),
                ...(count !== null ? { count } : null),
                ...query,
            },
            opts,
        ).catch((e) => {
            if (e.status === 404) {
                return null;
            }
            throw e;
        });
    }

    regions(query = null, slug = null, opts = null) {
        return this.getJSON<ApiRegionsResponse>(
            '/regions',
            {
                uri: slug,
                ...query,
            },
            opts,
        ).catch((e) => {
            if (e.status === 404) {
                return null;
            }
            throw e;
        });
    }
}

export default Locations;
